export class ContentTypesActionsService<T> {
	handlers: Set<(data: T) => void> = new Set();

	dispose() {
		this.handlers.clear();
	}

	updateActions(data: T) {
		this.handlers.forEach((handler) => handler(data));
	}

	onActionsUpdate(cb: (data: T) => void) {
		this.handlers.add(cb);

		return () => {
			this.handlers.delete(cb);
		};
	}
}
